import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchResultsComponent } from 'src/app/pages/search/results/results.component';
import { AccountGuard } from './guards/account.guard';
import { NoauthLayoutComponent } from './layouts/noauth-layout/noauth-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { DashboardRedirectComponent } from './pages/home/dashboard.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';

// important all routes must have children /search/result/?search=xxx
const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
            path: '',
            component: DashboardRedirectComponent,
            canActivate: [AccountGuard],
            pathMatch: 'full',
      },
      {
            path: 'search',
            canActivateChild: [AccountGuard],
            children: [
              {
                path: 'results',
                component: SearchResultsComponent,
              },
            ],
      },
      {
            path: 'dashboards',
            canActivateChild: [AccountGuard],
            children: [
              {
                path: 'home',
                loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
              },
            ],
      },
      {
            path: 'claims',
            loadChildren: () => import('./pages/claims/claims.module').then((m) => m.ClaimsModule),
            canActivateChild: [AccountGuard],
      },
      {
            path: 'financials',
            loadChildren: () => import('./pages/financials/financials.module').then((m) => m.FinancialsModule),
            canActivateChild: [AccountGuard],
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('./pages/externalconfiguration/externalconfiguration.module').then(
            (m) => m.ExternalconfigurationModule
        ),
        canActivateChild: [AccountGuard],
      },
      {
            path: 'reporting',
            loadChildren: () => import('./pages/reporting/reporting.module').then((m) => m.ReportingModule),
            canActivateChild: [AccountGuard],
      },
      {
            path: 'users',
            loadChildren: () => import('./pages/users/users.module').then((m) => m.UsersModule),
            canActivateChild: [AccountGuard],
      },
      {
            path: 'wallets',
            loadChildren: () => import('./pages/wallets/wallets.module').then((m) => m.WalletsModule),
            canActivateChild: [AccountGuard],
      },
      {
            path: 'workorders',
            loadChildren: () => import('./pages/workorders/workorder.module').then((m) => m.WorkOrdersModule),
            canActivateChild: [AccountGuard],
      },
      {
        path: 'ids',
        loadChildren: () =>
          import('./pages/identification/identification.module').then(
            (m) => m.IdentificationModule
          ),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'exemption',
        loadChildren: () => import('./pages/exemption/exemption.module').then((m) => m.ExemptionModule),
      },
      {
        path: 'mz',
        loadChildren: () => import('./pages/mz/mz.module').then((m) => m.MzModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: "kmt",
        loadChildren: () =>
          import("./pages/kmt/kmt.module").then((m) => m.KmtModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'asm/nodes/:name',
        loadComponent: () =>
          import('./pages/asset-manager/worker-log/worker-log.component').then(
            (m) => m.WorkerLogComponent
          ),
        canActivate: [AccountGuard],
      },
      {
        path: 'applicationinsight',
        loadComponent: () =>
          import('./pages/application-insight/application-insight.component').then(
            (m) => m.ApplicationInsightComponent
          ),
        canActivate: [AccountGuard],
      },
      {
        path: 'system',
        loadChildren: () => import('./pages/system/system.module').then((m) => m.SystemModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'esb',
        loadChildren: () => import('./pages/esb/esb.module').then((m) => m.EsbModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'tests',
        loadChildren: () => import('./pages/tests/test.module').then((m) => m.TestModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'docs',
        loadChildren: () => import('./pages/docs/docs.module').then((m) => m.DocsModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'documents',
        loadChildren: () => import('./pages/print/print.module').then((m) => m.PrintModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'upload',
        loadChildren: () => import('./pages/upload/upload.module').then((m) => m.UploadModule),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'changepassword',
        loadChildren: () =>
          import('./pages/change-password/change-password.module').then(
            (m) => m.ChangePasswordModule
          ),
      },
      {
        path: 'mfa',
        loadChildren: () =>
          import('./pages/mfa-setup/mfa-setup.module').then(
            (m) => m.MfaSetupModule
          ),
        canActivateChild: [AccountGuard],
      },
      {
        path: 'management',
        loadChildren: () =>
          import(
            './pages/dynamic-components-management/dynamic-components-management.module'
          ).then((m) => m.DynamicComponentsManagementModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.module').then((m) => m.AdminModule),
      },
      // {
      //   path: 'caz-work',
      //   loadChildren: () => import('./pages/caz/caz.module').then((m) => m.CazModule), canActivateChild: [AccountGuard],
      // },
    ],
  },
  {
    path: 'login',
    component: NoauthLayoutComponent,
    loadChildren: () =>
      import('./components/auth/auth.module').then((m) => m.LoginModule),
  },
  {
    path: 'passwordexpired',
    component: NoauthLayoutComponent,
    loadChildren: () =>
      import('./pages/password-expired/password-expired.module').then(
        (m) => m.PasswordExpiredModule
      ),
  },
  // {
  //   path: 'tfgm',
  //   component: BlankLayoutComponent,
  //   loadChildren: () => import('./pages/caz/caz.module').then((m) => m.CazModule), canActivateChild: [AccountGuard],
  // },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: false,
    
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
